import { render, staticRenderFns } from "./TreatmentDirectory.vue?vue&type=template&id=02048ab2&scoped=true"
import script from "./TreatmentDirectory.vue?vue&type=script&lang=js"
export * from "./TreatmentDirectory.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDirectory.vue?vue&type=style&index=0&id=02048ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02048ab2",
  null
  
)

export default component.exports